<template>
  <v-app dark>
    <v-main>
      <Navigation v-if="isAuthenticated && !printingInProgress"></Navigation>
      <router-view></router-view>
      <Loader v-show="loading" :loading="loading" />
      <v-snackbar
        v-model="snackbar.value"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        right
      >{{ snackbar.text }}</v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import Loader from "./components/Loader";
import Navigation from "./components/Navigation";

export default {
  name: "App",
  components: {
    Loader,
    Navigation,
  },
  data: () => ({
    //
  }),
  computed: {
    ...mapState(["loading", "snackbar", "isAuthenticated", "printingInProgress"])
  }
};
</script>

<style lang="scss">
.v-alert--dense .v-alert__border {
  border-width: 4px!important;
}
.v-application .teal {
  color: #fff !important;
}
.v-main {
  background: $bg1;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    color: #fff;
    user-select: none;
  }
}
.v-text-field--outlined.v-input--dense .v-label {
  color: #8b8b8b!important;
}
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  background: transparent;
}
input {
  color: $inputColor;
}
.v-file-input {
  .v-label {
    color: $inputColor;
  }
  .v-input__slot {
    background: $bgInputColor;
    padding-left: 10px;
  }
}
.v-select.v-input--dense .v-select__selection--comma {
  color: $inputColor;
}
.main-container {
  padding: 10px 20px 20px 60px;
}
.main-title {
  padding-left: 70px;
  padding-top: 20px;
  padding-bottom: 10px;
  color: rgb(158 158 158 / 0.2);
}

.v-messages__message {
  color: $error;
}

.v-text-field--outlined.error--text fieldset {
  border-color: $error;
}

@media (max-width: 768px) {
  .main-title {
    padding: 20px 0 0 0;
    font-size: 20px;
  }
  .main-container {
    padding: 20px 0 20px 0;
  }
}
</style>